<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
     <a-form-model-item label="师傅" prop="masterName" >
        <a-input v-model="form.masterName" :disabled="true"/>
      </a-form-model-item>
     <a-form-model-item label="工种" prop="professionName" >
        <a-input v-model="form.professionName" :disabled="true"/>
      </a-form-model-item>
      <a-form-model-item v-if="idPictureList.length" label="证件图片">
        <img
          v-for="(pic, idx) in idPictureList"
          :key="idx"
          v-viewer
          :src="pic"
          preview="图片"
          style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;"
        />
      </a-form-model-item>
      <a-form-model-item label="到期时间" prop="expirationDate">
        <a-date-picker
          v-model="form.expirationDate"
          format="YYYY-MM-DD"
          placeholder="请选择到期时间"
          style="width: 100%" valueFormat="YYYY-MM-DD"
        />
      </a-form-model-item>
      <a-form-model-item label="审核状态" prop="examineStatus">
        <a-select v-model="form.examineStatus" placeholder="请选择审核状态">
          <a-select-option :value="0">待审核</a-select-option>
          <a-select-option :value="1">已通过</a-select-option>
          <a-select-option :value="2">已驳回</a-select-option>
        </a-select>

      </a-form-model-item>
      <a-form-model-item label="审核原因" prop="examineReason">
        <a-input v-model="form.examineReason" placeholder="请输入审核原因"/>
      </a-form-model-item>
      <!--      <a-form-model-item label="备注" prop="remark" >
              <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
            </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {addAuthentication, getAuthentication, updateAuthentication} from '@/api/profession/authentication'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        professionId: null,

        idPicture: null,

        expirationDate: null,

        examineStatus: 0,

        examineReason: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '师傅id,外键{}不能为空', trigger: 'blur' }
        ],
        professionId: [
          { required: true, message: '工种id,外键{zb_profession.id}不能为空', trigger: 'blur' }
        ],
        examineStatus: [
          { required: true, message: '审核状态,0-待审核,1-已通过,2-已拒绝不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    /** 有有效 URL 时才展示证件图区域 */
    idPictureList () {
      const raw = this.form && this.form.idPicture
      if (!raw || typeof raw !== 'string') {
        return []
      }
      return raw.split(',').map(s => (s || '').trim()).filter(Boolean)
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        professionId: null,
        idPicture: null,
        expirationDate: null,
        examineStatus: 0,
        examineReason: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAuthentication({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = response.data.examineStatus === 0 ? '审核' : '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateAuthentication(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addAuthentication(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
